import FlowTerminusLayout from '~/client/components/flow-terminus-layout/flow-terminus-layout';

export default FlowTerminusLayout;
